export default __webpack_public_path__ + "static/media/a_classic_caper.23036948.svg";